import {
  compactShowcaseItems,
  featuredShowcaseItem,
  resolveShowcaseEntry,
  toShowcaseCardData,
} from '../../content';
import { ShowcaseCard } from '../ui/showcase/ShowcaseCard';
import './selected-work.scss';

export const SelectedWork = () => {
  const featuredEntry = resolveShowcaseEntry(featuredShowcaseItem);
  const featured = featuredEntry
    ? toShowcaseCardData(featuredEntry, featuredShowcaseItem.layout, featuredShowcaseItem.kind)
    : null;

  const compactCards = compactShowcaseItems
    .map((item) => {
      const entry = resolveShowcaseEntry(item);
      return entry ? toShowcaseCardData(entry, item.layout, item.kind) : null;
    })
    .filter((card): card is NonNullable<typeof card> => card !== null);

  return (
    <section className="container">
      <h2 className="h1 text-center mb-3">Selected Work</h2>
      <p className="mb-5 mx-auto fs-lg text-center works-label">
        Real systems built for teams operating in real-world environments.
      </p>
      <div className="row selected-work-grid">
        <div className="col-lg-5 col-12 mb-4 mb-lg-0 selected-work-featured">
          {featured ? <ShowcaseCard {...featured} /> : null}
        </div>
        <div className="col secondary-showcase-cards-container">
          {compactCards.map((card) => (
            <ShowcaseCard key={card.title} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
};
